import { Transforms, Location } from 'slate';
import { ReactEditor } from 'slate-react';
import { insertVoidElement } from '../../lib/commands';
import { AulaEditorInstance } from '../../types';
import { googleDriveType } from './googleDriveType';
import {
  GoogleApiLoader,
  GapiOauthTokenResponse,
  PickerResult,
  GIS,
  GISClient,
} from './types';

declare const gapi: GoogleApiLoader;
declare const google: GIS;

const clientId =
  '764378899916-77tump3t55prq8dn06bd2qc51ooabods.apps.googleusercontent.com';
const authScope = 'https://www.googleapis.com/auth/drive.readonly';
const developerKey = 'AIzaSyDUzqYLi-E9XpogKItr5W6D6n2qHO2k5Cg';

let accessToken: string;
let tokenClient: GISClient;

// Loads the GoogleDrive picker API, if not already available
const loadGoogleDriveApiIfNecessary = async () => {
  if (typeof gapi.picker === 'undefined') {
    return new Promise<void>((resolve) => {
      gapi.load('picker', () => {
        tokenClient = google.accounts.oauth2.initTokenClient({
          client_id: clientId,
          scope: authScope,
          // Callback defined later as per https://developers.google.com/drive/picker/guides/overview
          callback: '',
        });
        resolve();
      });
    });
  }

  return Promise.resolve();
};

export const openGoogleDrivePicker = async (
  editor: AulaEditorInstance,
  location: Location
) => {
  await loadGoogleDriveApiIfNecessary();

  const showPicker = () => {
    const picker = new gapi.picker.api.PickerBuilder()
      .addView(gapi.picker.api.ViewId.DOCS)
      .setOAuthToken(accessToken)
      .setDeveloperKey(developerKey)
      .enableFeature(gapi.picker.api.Feature.NAV_HIDDEN)
      .enableFeature(gapi.picker.api.Feature.MULTISELECT_ENABLED)
      .setCallback((pickerResult: PickerResult) => {
        if (pickerResult.action !== 'picked') return;

        Transforms.select(editor, location);

        // Insert an element for each of the selected files from google drive, if any:
        pickerResult.docs.forEach((result) => {
          insertVoidElement(editor, {
            type: googleDriveType,
            viewUrl: result.url,
            embedUrl: result.embedUrl,
            title: result.name,
          });
          setTimeout(() => {
            ReactEditor.focus(editor);
          }, 100);
        });
      })
      .build();

    picker.setVisible(true);

    // Ensure the picker is on top of any modals/menus.
    // We need to set all pickers since old ones are not removed from DOM after use.
    Array.from(document.getElementsByClassName('picker picker-dialog')).forEach(
      (element) => {
        // eslint-disable-next-line no-param-reassign
        (element as HTMLElement).style.zIndex = '1600';
      }
    );
  };

  tokenClient.callback = async (response: GapiOauthTokenResponse) => {
    if (response.error !== undefined) {
      console.error(response.error);
      return;
    }

    accessToken = response.access_token;
    showPicker();
  };

  if (accessToken === null) {
    tokenClient.requestAccessToken({ prompt: 'consent' });
  } else {
    // Skip display of account chooser and consent dialog for an existing session.
    tokenClient.requestAccessToken({ prompt: '' });
  }
};
